export const ROOT_ROUTE = '';
export const HAWKER_COMMISSARY_ASSIGNMENT_HISTORY_MODULE =
  'hawker-commissary-assignment-history';
export const HAWKER_COMMISSARY_ASSIGNMENT_MODULE =
  'hawker-commissary-assignment';
export const HAWKER_SESSION_MODULE = 'hawker-session';
export const HAWKER_SESSION_ADMIN_MODULE = 'hawker-session-admin';
export const HAWKER_PROFILE_MODULE = 'hawker-profile';
export const HAWKER_LOAD_MODULE = 'hawker-load';
export const TRANSFER_GROUP_TEMPLATE_MODULE = 'transfer-group-template';
export const EMPTY_ROUTE = '/';

export const DASHBOARD_ROUTE = 'dashboard';
export const LOGIN_ROUTE = 'login';
export const LOG_OUT_ROUTE = 'log-out';
export const ERROR_PAGE_ROUTE = 'error';
export const IFRAME_MODE = 'external_login';
export const LANDING_PAGE = 'landing-page';
export const ORDER_MODULE = 'order';
export const TRANSFER_MODULE = 'transfer';
export const STAND_WORKSHEET_MODULE = 'stand-worksheet';
export const INVENTORY_COUNT_MODULE = 'inventory-count';
export const INVENTORY_COUNT_GROUP_MODULE = 'inventory-count-group';
export const HISTORICAL_TRANSFER_QUANTITIES_MODULE = 'historical-quantities';
export const INCOMPLETE_TRANSFER_MODULE = 'incomplete-transfer';
export const TRANSFER_GROUP_MODULE = 'transfer-group';
export const FILTERED_ORDER_MODULE = 'filtered-order';
export const FILTERED_TRANSFER_MODULE = 'filtered-transfer';
export const TRANSFER_REQUEST_MODULE = 'transfer-request';
